import React from 'react'
import styled from 'styled-components'

import RehypeReact from 'rehype-react'

import { components } from '../cms/configuration'

const renderAst = new RehypeReact({ createElement: React.createElement, components }).Compiler

const StyledContentViewer = styled.div`
  max-width: ${props => props.theme.maxPageContentWidth};

  font-family: ${props => props.theme.bodyFontFamily};
  padding: 0 1rem;
  table {
    border-collapse: collapse;
    margin: 0 auto;
  }

  table, th, td {
    border: 1px solid rgba(0,0,0,.25);
    padding: .5rem;
  }

  tr:nth-child(odd){
    background: rgba(0,0,0,.1);
  }
  th{
    background: gold;
    border-color: rgba(0,0,0,.25);
  }
  p img{
    width: 100%;
  }
`

export const ContentViewer = ({ content }) => <StyledContentViewer dangerouslySetInnerHTML={{ __html: content }} />

export const ContentPassThrough = ({ children }) => <StyledContentViewer>{children}</StyledContentViewer>

export const ContentAstViewer = ({ content }) => <StyledContentViewer>{ renderAst(content) }</StyledContentViewer>
